import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const restoreResearchWorkItem = async (
  workItemId: string,
  version: number
): Promise<IResearchWorkItem> => {
  const response = await apiClient.delete(
    `/research/work-items/${workItemId}/archival`,
    { data: { version } }
  );

  return response.data;
};
